module.exports = {
  brentcross: require('./brentcross.json'),
  bullring: require('./bullring.json'),
  cabotcircus: require('./cabotcircus.json'),
  centralewhitgift: require('./centralewhitgift.json'),
  dundrum: require('./dundrum.json'),
  espacestquentin: require('./espacestquentin.json'),
  highcross: require('./highcross.json'),
  ilac: require('./ilac.json'),
  italiedeux: require('./italiedeux.json'),
  lesterrassesduport: require('./lesterrassesduport.json'),
  lestroisfontaines: require('./lestroisfontaines.json'),
  nicetoile: require('./nicetoile.json'),
  oparinor: require('./oparinor.json'),
  oracle: require('./oracle.json'),
  pavilions: require('./pavilions.json'),
  silverburn: require('./silverburn.json'),
  unionsquare: require('./unionsquare.json'),
  victorialeeds: require('./victorialeeds.json'),
  westquay: require('./westquay.json')
};